import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC } from "react";
import { Pie } from "react-chartjs-2";
//import ChartDataLabels from 'chartjs-plugin-datalabels';
import styled from "styled-components";
import { StuntTypeProp } from "../../../CustomTypes/Filters";
//import { useDashboardData } from "../../../Hooks/useDashboard";
import { useHookForApi } from "../../../Hooks/useHookForApi";
import CustomToast from "../../CustomToast/CustomToast";
//import LoadingIndicator from "../../LoadingIndicator/index";
// import "./dashboard.scss";
import { errorToast } from "../../../Utils/toastMessage";

const ChartWarapper = styled.div`
  max-width: auto;
  margin: 0 auto;
`;

const PurchaseOrder: FC<StuntTypeProp> = (stuntType) => {   
    const onSuccess = (data: any) => {      
        //if (data === 'undefined') {
        if (data.isAxiosError && data.name==='Error' && data.message==="Network Error") {
            errorToast(JSON.stringify(`Unable to connect with Purchase Order service and possible reason : (${data})`));         
        }
    };
    const onError = (error: any) => {       
    };

    //purchaseorders/dashboard
    const {
        //isLoading: isDataLoading,
        data:response,
        //isFetching,
    } = useHookForApi(onSuccess, onError ,0,0, `purchaseorders/dashboard${stuntType.stuntType}`);

    const dashboardData = {
        labels: ["Expected", "Received"],
        datasets: [
            {
                label: "# of Votes",
                data: [response?.data?.expected, response?.data?.received],
                backgroundColor: ["rgba(241, 90, 36, 1)", "rgba(115, 115, 115, 1)"],
                borderColor: ["rgba(241, 90, 36, 1)", "rgba(115, 115, 115, 1)"],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: true,
                color: "black",
                formatter: (value: any, ctx: any) => {
                    let sum = 0;
                    const dataArr = ctx.chart.data.datasets[0].data;
                    sum = dataArr.reduce((prev: any, cur: any) => prev + cur);
                    const percentage = ((value * 100) / sum).toFixed(2) + "%";
                    if (percentage === "NaN%" || percentage === "0.00%") {
                        return "";
                    }
                    return percentage;
                },
            },
        },
    };

    // const calculatePercentage = (total: number, currentValue: number) => {
    //   return Math.floor((currentValue / total) * 100 + 0.5);
    // };

    return (
        <>
            <div className="ln-u-soft colour">
                <GridWrapper equalHeight>
                    <GridItem size="1/2">
                        <div className="property">Number of Purchase Order
                            <h2 className="shippedTomorrowValue">{response?.data?.totalCount}</h2></div>
                    </GridItem>
                </GridWrapper>

                <GridWrapper equalHeight>
                    <GridItem size="1/2">
                        <ChartWarapper>
                            <Pie data={dashboardData} options={options} />
                        </ChartWarapper>
                    </GridItem>
                    <GridItem size="1/2">
                        <div className="" style={{ position: 'relative' }}>
                            <div className="purchaseOrderPosition">
                                <p className="property">
                                    {/* Number of Purchase Order {data?.totalCount} */}
                                </p>
                                <div className="parent">
                                    Expected ({response?.data?.expected})&nbsp;
                                    <div className="child expected"></div>
                                </div>
                                <div className="parent">
                                    Received ({response?.data?.received}) &nbsp;
                                    <div className="child received"></div>
                                </div>
                            </div>
                        </div>
                    </GridItem>
                </GridWrapper>
            </div>  
            <CustomToast/>
        </>
    );
};

export default PurchaseOrder;
